'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ALLOW_MULTI_SELECT = exports.ALLOW_MULTI_SELECT = ['allowMultiSelect'];

var ALLOW_USER_INPUT = exports.ALLOW_USER_INPUT = ['allowUserInput'];

var QUICK_REPLIES = exports.QUICK_REPLIES = ['quickReplies'];